module.exports = __webpack_public_path__ + "static/img/ls45.c9749fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/ls45.png
// module id = UhiW
// module chunks = 12